"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IlActionsBanner = exports.IlActionsBannerArgs = exports.IlCustomIconBanner = exports.IlCustomIconArgs = exports.IlSuccessBanner = exports.IlSuccessBannerArgs = exports.IlInfoBanner = exports.IlInfoBannerArgs = exports.IlMaintenanceBanner = exports.IlMaintenanceBannerArgs = exports.IlErrorBanner = exports.IlErrorBannerArgs = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var enums_1 = require("../../shared/enums");
var get_component_1 = require("../../shared/helpers/get-component");
var solid_icon_definitions_1 = require("../il-icon/solid-icon-definitions");
var il_banner_1 = require("./il-banner");
exports.IlErrorBannerArgs = {
    title: 'Error Message',
    description: 'We´re experiencing an issue, try again in a few minutes',
    color: enums_1.ColorPaletteEnum.ERROR,
    iconType: solid_icon_definitions_1.SolidIconDefinitions.X_MARK_ICON,
    titleSx: {
        color: 'error.main',
    },
};
exports.IlErrorBanner = (0, get_component_1.getComponent)(il_banner_1.ILBanner, exports.IlErrorBannerArgs);
exports.IlMaintenanceBannerArgs = {
    title: 'Warning Message',
    description: 'Warning Alert for something that may disrupt user´s experience',
    color: enums_1.ColorPaletteEnum.WARNING,
    iconType: solid_icon_definitions_1.SolidIconDefinitions.WRENCH,
};
exports.IlMaintenanceBanner = (0, get_component_1.getComponent)(il_banner_1.ILBanner, exports.IlMaintenanceBannerArgs);
exports.IlInfoBannerArgs = {
    title: 'Info Message',
    description: 'Your account is holding confirmation, please check your email',
    color: enums_1.ColorPaletteEnum.INFO,
    iconType: solid_icon_definitions_1.SolidIconDefinitions.INFO,
};
exports.IlInfoBanner = (0, get_component_1.getComponent)(il_banner_1.ILBanner, exports.IlInfoBannerArgs);
exports.IlSuccessBannerArgs = {
    title: 'Success Message',
    description: 'Your account is confirmed, please login to continue',
    color: enums_1.ColorPaletteEnum.SUCCESS,
    iconType: solid_icon_definitions_1.SolidIconDefinitions.CHECK,
};
exports.IlSuccessBanner = (0, get_component_1.getComponent)(il_banner_1.ILBanner, exports.IlSuccessBannerArgs);
exports.IlCustomIconArgs = {
    title: 'Custom Message',
    description: 'Some custom information message',
    color: enums_1.ColorPaletteEnum.INFO,
    icon: react_1.default.createElement(react_1.default.Fragment, null, "a"),
};
exports.IlCustomIconBanner = (0, get_component_1.getComponent)(il_banner_1.ILBanner, exports.IlCustomIconArgs);
exports.IlActionsBannerArgs = {
    title: 'With Action',
    description: 'Some custom information message with actions',
    color: enums_1.ColorPaletteEnum.INFO,
    icon: react_1.default.createElement(react_1.default.Fragment, null, "a"),
    children: (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(material_1.Button, { variant: enums_1.ButtonVariantEnum.TEXT }, "Dismiss"),
        react_1.default.createElement(material_1.Button, { variant: enums_1.ButtonVariantEnum.TEXT }, "Update"))),
};
exports.IlActionsBanner = (0, get_component_1.getComponent)(il_banner_1.ILBanner, exports.IlActionsBannerArgs);
